import { Link } from "react-router-dom";
import Header from "@/components/Header";
import SeoHead from "@/components/SeoHead";
import { ArrowLeft } from "@phosphor-icons/react";

export const LegalLayout = ({ title, children }) => (
  <div className="min-h-screen bg-slate-50">
    <SeoHead
      title={`${title} | Servus Autoglas`}
      description={`${title} der AutoGlas Erol GmbH (Servus Autoglas) in Ludwigshafen am Rhein.`}
    />
    <Header minimal />
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10">
      <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-900 mb-6" data-testid="legal-back-link">
        <ArrowLeft size={16} /> Zurück zur Startseite
      </Link>
      <article className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6 sm:p-10 prose prose-slate max-w-none prose-headings:font-bold prose-headings:tracking-tight prose-h1:text-3xl prose-h1:mb-6 prose-h2:text-xl prose-h2:mt-8 prose-h2:mb-3 prose-h3:text-base prose-p:text-slate-700 prose-p:leading-relaxed prose-li:text-slate-700 prose-a:text-blue-600 prose-strong:text-slate-900">
        <h1>{title}</h1>
        {children}
      </article>
    </div>
  </div>
);

export default LegalLayout;
